import UnsplashRunClient from "./UnsplashRunClient";
import ClientRunnerServiceClient from "./ClientRunnerServiceClient";
import FileServiceClient from "./FileServiceClient";
import ProjectServiceClient from "./ProjectServiceClient";
import UniqueCheckerClient from "./UniqueCheckerClient";
import StudioServiceClient from "./StudioServiceClient";

export default class RPCServices {
  private static _projectService: ProjectServiceClient;
  private static _clientRunnerService: ClientRunnerServiceClient;
  private static _unsplashRun: UnsplashRunClient;
  private static _studioService: StudioServiceClient;
  private static _uniqueChecker: UniqueCheckerClient;
  private static _fileService: FileServiceClient;
  public static getProjectService(): ProjectServiceClient {
    if (RPCServices._projectService == null) {
      RPCServices._projectService = new ProjectServiceClient();
    }

    return RPCServices._projectService;
  }
  public static getClientRunnerService(): ClientRunnerServiceClient {
    if (RPCServices._clientRunnerService == null) {
      RPCServices._clientRunnerService = new ClientRunnerServiceClient();
    }

    return RPCServices._clientRunnerService;
  }
  public static getUnsplashRun(): UnsplashRunClient {
    if (RPCServices._unsplashRun == null) {
      RPCServices._unsplashRun = new UnsplashRunClient();
    }

    return RPCServices._unsplashRun;
  }
  public static getStudioService(): StudioServiceClient {
    if (RPCServices._studioService == null) {
      RPCServices._studioService = new StudioServiceClient();
    }

    return RPCServices._studioService;
  }
  public static getUniqueChecker(): UniqueCheckerClient {
    if (RPCServices._uniqueChecker == null) {
      RPCServices._uniqueChecker = new UniqueCheckerClient();
    }

    return RPCServices._uniqueChecker;
  }
  public static getFileService(): FileServiceClient {
    if (RPCServices._fileService == null) {
      RPCServices._fileService = new FileServiceClient();
    }

    return RPCServices._fileService;
  }
}
